import { useCompaniesStore } from '@/stores/useCompaniesStore';
import { useEmpregadoresStore } from '@/stores/useEmpregadoresStore';
import { useEmpresasStore } from '@/stores/useEmpresasStore';

export function resetCompanyStores() {
  useCompaniesStore.getState().reset();
  useEmpregadoresStore.getState().reset();
  useEmpresasStore.getState().reset();
}
